'use strict'
import { axios, getErrorMessage } from '../helpers/axioshelper'

export default {
  getAllScales() {
    return new Promise((resolve, reject) => {
      axios
        .get('/api/scales')
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addScale(scale) {
    return new Promise((resolve, reject) => {
      axios
        .post('/api/scales', scale)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateScale(scale) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/scales/${scale.id}`, scale)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addScaleContent(scaleId, content) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/scales/${scaleId}/content`, content)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  updateScaleContent(scaleId, content) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/scales/${scaleId}/content/${content.id}`, content)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteScale(scaleId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/scales/${scaleId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  deleteScaleContent(scaleId, scaleContentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/scales/${scaleId}/content/${scaleContentId}`)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  getQuestions(scaleId, languageId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/scales/${scaleId}/questions/${languageId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  saveQuestions(scaleId, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/scales/${scaleId}/questions`, data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}
